import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * useInterviewSimSession — GET /api/cabin/interview-sim/{id}
 * Returns session detail with scoring if available
 */
export function useInterviewSimSession(sessionId) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSession = useCallback(async () => {
    if (!sessionId) return;
    setLoading(true);
    setError(null);
    try {
      const token = getToken();
      const res = await axios.get(`${API}/cabin/interview-sim/${sessionId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSession(res.data);
    } catch (err) {
      const status = err?.response?.status;
      const msg =
        err?.response?.data?.message_tr ||
        err?.response?.data?.detail ||
        err.message;
      setError(msg);
      if (status === 401 || status === 403) {
        // Auth errors bubble up as-is; caller should redirect
      }
    } finally {
      setLoading(false);
    }
  }, [sessionId]);

  useEffect(() => {
    fetchSession();
  }, [fetchSession]);

  return { session, loading, error, refetch: fetchSession };
}
